import React from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  BarChart, 
  Bar, 
  Cell, 
  Legend, 
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,

} from "recharts";

export default function Chart({ data, mediaTypes, target, dataKey, onClick }) {
  const theme = useTheme();
  
  const timestanp = (date) => {
    switch (target) {
      case "monthly":
        return dayjs(date).format("YYYY-MM-DD");
      case "daily":
        return dayjs(date).format("YYYY-MM-DD HH:00");
      case "hourly":
        // 5分単位に丸める(0詰め2桁)
        const roundMinute = ("0" + parseInt((dayjs(date).minute())/5)*5).slice(-2);
        return (dayjs(date).format("YYYY-MM-DD HH:")) + roundMinute;
    }
  }

  // barカラー設定
  const barColor = {
    0: "#535c68",
    1: "#eb4d4b",
    2: "#4834d4",
    3: "#f9ca24",
    4: "#badc58",
    5: "#f0932b",
    6: "#7ed6df",
    7: "#ff7979",
    8: "#6ab04c",
    9: "#30336b",
    10: "#e056fd",
  }

  return (
    <React.Fragment>
      <ResponsiveContainer>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          onClick={(data) => 
            {
              if (data != null) {
                return onClick(data.activeLabel)
              }
            }
          }
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={dataKey} />
          <YAxis />
          <Tooltip />
          <Legend />
          {mediaTypes.map((type, index) => (
            // <Bar dataKey={type.label} stackId="a" fill={barColor[type.id]} />
            <Bar key={index} dataKey={type.label} stackId="a" fill={type.color} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
